import { useLayoutContext } from "@context/layout";
import { toFarsiNumber } from "@utils/digits";
import Link from "next/link";
import { FC } from "react";

interface Props {
  closeHandler?: () => void;
}

const SubscriptionRemainingDays: FC<Props> = ({ closeHandler }) => {
  const { subscriptionData } = useLayoutContext();

  if (!subscriptionData?.is_active) return null;

  const remainingDays = toFarsiNumber(
    Math.max(1, subscriptionData.remaining_days ?? 1)
  );

  return (
    <Link
      href="/my-account/subscription"
      onClick={() => closeHandler?.()}
      className="block w-full py-2.5 rounded-8 border-[0.8px] border-fds-brand-light hover:border-fds-brand transition-colors subscription-remaining-days-bg"
    >
      <p className="text-fds-primary body-sm px-4">
        <span className="headline-sm text-fds-brand-select">
          {remainingDays} روز
        </span>{" "}
        تا پایان اشتراک
      </p>
    </Link>
  );
};

export default SubscriptionRemainingDays;
